import { Species } from './species';
import { TranslateService } from '@ngx-translate/core';

export class VaccineValence {
    id: number | null = null;
    species: Species | undefined = undefined;
    name: string = '';
    fullName: string = '';
    description: string = '';
    isDisplayOnHome: boolean = false;
}

export class VaccineLabel {
    id: number | null = null;
    valences: VaccineValence[] = [];
    name: string = '';
}

export class VaccineConfiguration {
    id: number | null = null;
    duration: string = ''
    durationMinBeforeNext: string = ''
    durationValidAfter: string = ''
    injectionNb: number = 1
    isBooster: boolean = false
    ageLessDays: number | null = 0
    ageSuqEqDays: number | null = 0
    specBB812: boolean = false


    durationLabel(translate: TranslateService) {
        if (this.duration.endsWith('y')) {
            return this.duration.replace('y', ' ' + translate.instant('year(s)'))
        }
        if (this.duration.endsWith('d')) {
            return this.duration.replace('d', ' ' + translate.instant('day(s)'))
        }
        if (this.duration.endsWith('m')) {
            return this.duration.replace('m', ' ' + translate.instant('month(s)'))
        }
        return ''
    }

    validAfterLabel(translate: TranslateService) {
        if (this.durationValidAfter.endsWith('y')) {
            return this.durationValidAfter.replace('y', ' ' + translate.instant('year(s)'))
        }
        if (this.durationValidAfter.endsWith('d')) {
            return this.durationValidAfter.replace('d', ' ' + translate.instant('day(s)'))
        }
        if (this.durationValidAfter.endsWith('m')) {
            return this.durationValidAfter.replace('m', ' ' + translate.instant('month(s)'))
        }
        return ''
    }
}
